import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdiantamentoInserirRoutingModule } from './adiantamento-inserir-routing.module';
import { AdiantamentoInserirComponent } from './adiantamento-inserir.component';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { InputMaskModule } from 'primeng/inputmask';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';


@NgModule({
  declarations: [
    AdiantamentoInserirComponent
  ],
  imports: [
    CommonModule,
    AdiantamentoInserirRoutingModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    DividerModule,
    MessagesModule,
    InputMaskModule,
    DropdownModule,
    CalendarModule,
    InputNumberModule
  ]
})
export class AdiantamentoInserirModule { }
